import { useWindowSize } from './useWindowSize';

export const MOBILE_THRESHOLD_WIDTH_PX = 800;

export function useIsMobile(treshold = MOBILE_THRESHOLD_WIDTH_PX): boolean {
  const { width } = useWindowSize();
  const isMobile = width !== undefined && width <= treshold;

  return isMobile;
}
